<template>
  <section
    class="Profile-view"
    :loading="loading"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="search-bar">
      <el-input
        v-model="searchString"
        placeholder="Search user, text, or document name"
        @keyup.native="onChangeSearchString"
        @clear="onChangeSearchString"
        clearable
      >
        <i
          slot="prefix"
          style="margin-top: -1px"
          class="el-input__icon el-icon-search"
        ></i>
      </el-input>
    </div>
    <hr />
    <div class="card mb-3" style="width: 100%">
      <div
        class=""
        style="width: 100%; min-height: 300px"
        v-loading="loading"
        element-loading-text="Loading..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <!-- <el-scrollbar wrap-style="max-height: 55vh; min-height: 160px"> -->
        <div
          class="sidemenu"
          v-if="Object.entries(allChatsGroupByDate).length > 0"
        >
          <div
            v-for="(value, name, index) in allChatsGroupByDate"
            :key="name"
            class="group-by-date"
          >
            <div class="date-row">
              <span class="left-side">{{ name | getFormattedDate }}</span>
              <div class="right-side">
                <a
                  @click="markAsReadChats"
                  v-if="index == 0 && filterType != 'All'"
                  class="mark-all-as-read"
                >
                  Mark all as read
                </a>
                <div v-if="index == 0">
                  <el-select
                    placeholder="Filter"
                    v-model="filterType"
                    class="filter-type-select"
                    @change="onFilterTypeSelected"
                  >
                    <el-option :key="0" :value="'All'" :label="'All'"
                      >All</el-option
                    >
                    <el-option :key="1" :value="'Unread'" :label="'Unread'"
                      >Unread</el-option
                    >
                  </el-select>
                </div>
              </div>
            </div>
            <div class="notification-row">
              <ul
                class="list-group list-group-flush"
                v-if="value && value.length"
              >
                <li
                  class="list-group-item notifcation-item"
                  v-for="(item, index) in value"
                  :key="index"
                  @click="goToDocView(item._id, true)"
                >
                  <div class="item-avatar">
                    {{ item | getUserNameAvatar }}
                    <div class="unread" v-if="!item.is_read"></div>
                  </div>
                  <div class="item-body">
                    <div class="item-body-left-child">
                      <p class="mb-0 text-secondary">
                        <span class="name">
                          {{ item | getUserFullName }}
                        </span>
                        <span class="commented-on"> commented on </span>
                        <span class="doc-name">
                          {{ item.title }}
                        </span>
                        {{ item.text | truncate(20, "...") }}
                      </p>
                      <span
                        class="date-time text-dark fw-medium pl-0 opacity-80"
                        >{{ item.created_at | getFormattedDateTypeThree }}</span
                      >
                      <!-- <div class="left-child">
                            <h4 class="name">{{ item | getUserFullName }}</h4>
														<span class="commented-on">
															commented on
														</span>
                            <span class="doc-name">
                              {{ item.title }}
                            </span>
                            <p class="mb-0 text-secondary">
                              {{ item.text }}
                               <span class="text-danger fw-medium">Offer Letter Doc</span> 
                            </p>
                          </div> -->
                    </div>
                    <span class="text-dark fw-medium pl-0 opacity-80">
                      {{ item.created_at | getFormattedDateTypeThree }}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-else class="no-data-for-notification">
          <div class="filter-type-select-wrapper">
            <el-select
              placeholder="Filter"
              v-model="filterType"
              class="filter-type-select"
              @change="onFilterTypeSelected"
            >
              <el-option :key="0" :value="'All'" :label="'All'">All</el-option>
              <el-option :key="1" :value="'Unread'" :label="'Unread'"
                >Unread</el-option
              >
            </el-select>
          </div>
          <div class="inner-wrapper">
            <div class="bg-img-wrapper">
              <div class="bg-img chat"></div>
            </div>
            <span>You have no unread chats yet.</span>
            <p>
              When you receive a chat on a document, it will be displayed here
              as unread.
            </p>
          </div>
        </div>
        <!-- </el-scrollbar> -->
      </div>
    </div>
  </section>
</template>

<script>
// import axios from "axios";
import axios from "@/config/axiosWithCancel";
import { mapActions } from "vuex";

export default {
  name: "notifications-ViewAllChats",
  data() {
    return {
      filterType: "All",
      searchString: "",
      loading: true,
      allChats: [],
      allChatsGroupByDate: {},
      allChatsGroupByDateAll: {},
      allChatsGroupByDateUnread: {},
    };
  },
  components: {},
  computed: {},
  mounted() {
    console.log(">>> mounted() called");
    this.fetchAllChats();
    this.fetchChats();
  },
  methods: {
    ...mapActions({
      fetchChats: "dashboard/fetchChats",
    }),
    async onFilterTypeSelected() {
      if (this.filterType == "All") {
        this.allChatsGroupByDate = this.allChatsGroupByDateAll;
      } else {
        this.allChatsGroupByDate = this.allChatsGroupByDateUnread;
      }
      console.log(
        ">>> onFilterTypeSelected(), this.allNotificationsGroupByDate",
        this.allChatsGroupByDateUnread
      );
    },
    async onChangeSearchString() {
      console.log(
        ">>> onChangeSearchString(), this.searchString",
        this.searchString
      );
      // if (this.searchString.length < 3)
      // {
      //   return;
      // }
      this.fetchAllChats();
    },
    goToDocView(document_id, isChat = false) {
      if (isChat) {
        this.markAsReadChats({ document_id });
      }
      if (document) {
        if (document.document_status == "DRAFT") {
          this.$router.push({
            name: "employee-documents-custom-document-edit",
            params: {
              employee_document_id: document_id,
            },
          });
        } else {
          this.$router.push({
            name: "employee-documents-custom-document",
            params: {
              employee_document_id: document_id,
            },
            query: { tab: "chat" },
          });
        }
      }
    },
    async markAsReadChats(query = {}) {
      try {
        await axios.post("all-documents/mark-as-read-notes", { query });

        if (this.getChatsUnReadCnt > 0) {
          await this.fetchChats();
        }
      } catch (err) {
        console.log(">>> markAsReadChats(), err", err);
      }
    },
    async fetchAllChats() {
      this.searchItems = null;

      try {
        this.loading = true;
        const params = {
          search_string: this.searchString,
        };
        let response = await axios.get("all-documents/get-all-notes", {
          params,
        });

        this.allChats = response.data.data;
        this.allChatsGroupByDateAll = {};
        // allChatsGroupByDate
        this.allChats.forEach((chat) => {
          // 2021-10-14
          var dt = chat.created_at.substring(0, 10);
          if (
            !Object.prototype.hasOwnProperty.call(
              this.allChatsGroupByDateAll,
              dt
            )
          ) {
            this.allChatsGroupByDateAll[dt] = [];
          }
          this.allChatsGroupByDateAll[dt].push(chat);
        });

        this.allChatsGroupByDateUnread = {};
        this.allChats.forEach((chat) => {
          // 2021-10-14
          if (!chat.is_read) {
            var dt = chat.created_at.substring(0, 10);
            if (
              !Object.prototype.hasOwnProperty.call(
                this.allChatsGroupByDateUnread,
                dt
              )
            ) {
              this.allChatsGroupByDateUnread[dt] = [];
            }
            this.allChatsGroupByDateUnread[dt].push(chat);
          }
        });

        this.onFilterTypeSelected();
        this.loading = false;
      } catch (err) {
        console.log(">>> fetchAllChats(), #3, err", err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sidemenu {
  height: 400px;
  overflow-y: scroll;
  overflow-x: scroll;
  border-top: 1px ridge;
  border-left: 1px ridge;
  border-bottom: 1px ridge;
}
.sidemenu::-webkit-scrollbar {
  width: 0.6em;
}
.sidemenu::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  background: #e1e1e1;
  -webkit-box-shadow: inset 0 0 6px rgba(172, 169, 169, 0.9);
}
.sidemenu::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #f5f5f5;
  background-color: #f5f5f5;
}
.card {
  border-bottom: none;
  .card-header {
    border-bottom: none;
  }
}
.list-group {
  border: none;
  width: 100%;
  max-width: 100%;
  .notifcation-item {
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.0525);
    cursor: pointer;
    padding: 10px 20px;
    display: grid;
    grid-template-columns: 2.75em 1fr;
    gap: 15px;
    @media (max-width: 499.98px) {
      // display: grid;
      padding: 5px 5px !important;
    }
    .item-avatar {
      border-radius: 50%;
      width: 40px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border: 1px solid #f754a2;
      background-color: rgba(#f754a2, $alpha: 0.1);
      color: #f754a2;
      .unread {
        position: absolute;
        z-index: 10000;
        width: 7px;
        height: 7px;
        top: 9px;
        left: 28px;
        border-radius: 8px;
        background: #40a0ff;
      }
    }
    .item-body {
      display: flex;
      justify-content: space-between;
      .item-body-left-child {
        .left-child {
          @media (min-width: 500px) {
            display: flex;
          }
        }
      }
      p {
        font-size: 13px;
        font-style: italic;
      }
      .name {
        font-style: normal;
        margin-bottom: 0;
        color: #6c757d !important;
        min-height: 21px;
        font-weight: 500;
        font-size: 15px !important;
        @media (min-width: 500px) {
          margin-right: 5px;
        }
      }
      .date-time {
        font-style: normal;
        min-width: 100px;
        @media (max-width: 499.98px) {
          min-width: 70px !important;
        }
        text-align: right;
        color: rgba(0, 0, 0, 0.5) !important;
        font-size: 12px;
      }
      .doc-name {
        font-style: normal;
        font-size: 13px !important;
        font-weight: 500;
        color: gray;
        margin-right: 10px;
        margin-left: 5px;
      }
    }
  }
}
.el-scrollbar {
  // border: 1px solid rgba(0, 0, 0, 0.125);
  // border-radius: 1px;
}
.group-by-date {
  .date-row {
    padding: 15px 10px;
    font-weight: 500;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .mark-all-as-read {
      color: #409eff;
      cursor: pointer;
      margin-right: 20px;
      line-height: 38px;
    }
    .right-side {
      display: flex;
      flex-direction: row;
    }
  }
  .notification-row {
    padding: 0 0px;
  }
}
</style>

<style lang="scss">
.all-chats-dialog {
  .el-dialog {
  }
  .el-dialog__body {
    padding: 0 !important;
  }
  // .Profile-view {
  //   .card {
  //     border: none !important;
  //   }
  // }
  hr {
    margin: 13px 0 !important;
  }
  .search-bar {
    margin-top: 12px;
    margin-left: 13px;
    margin-right: 10px;
    display: flex;
    i.el-icon-search {
      // border: 2px solid #e7eaf3 !important;
      // border-right: none !important;
      // padding: 10px;
      margin-top: 10px;
    }
    div.el-input {
      width: 95%;
      margin-left: 10px !important;
      // border: 2px solid #e7eaf3 !important;
      // border-left: none !important;
      // width: 98%;
      // &:focus-visible {
      //   outline: none !important;
      // }
    }
  }
  .filter-type-select {
    width: 120px;
    margin-right: 10px;
  }
  .no-data-for-notification {
    display: flex;
    flex-direction: column;
    .filter-type-select-wrapper {
      text-align: right;
      margin-right: 10px;
    }
  }
}
</style>